const koCreateFile: Record<string, { message: string; description: string }> = {
  "ledgerEditor.nameYourFile": {
    message: "파일 이름 입력...",
    description: "Placeholder for file name input",
  },
};

export default koCreateFile;
